import classnames from "classnames";
import React from "react";
import { T2sSlider } from "src/components";

import { Slice } from "../components";
import { ISliceSliderT2s } from "../types";

export const SliderT2s = ({
  slice_type,
  primary,
  items,
}: ISliceSliderT2s): JSX.Element | null => {
  const {
    class_name: className,
    max_slides: maxSlides,
    has_dots: dots,
    t2s_title: title,
    t2s_space_id: spaceId,
    t2s_show_price: showPrice,
    t2s_show_rating: showRating,
  } = primary;

  if (!spaceId || spaceId === "") {
    return null;
  }

  return (
    <Slice className={classnames("slice-slider-t2s", className)} noGutter>
      <T2sSlider
        options={{ spaceId, title, dots, showPrice, showRating, maxSlides }}
      />
    </Slice>
  );
};
